import styled from 'styled-components'

import type { ClassNameProps } from '@root/shared/react'

type InstantTradeBottomQuickOptionProps = {
  label: string
  onClick: () => void
  active?: boolean
} & ClassNameProps

export const InstantTradeBottomQuickOption: React.FC<
  InstantTradeBottomQuickOptionProps
> = ({ className, label, active, onClick }) => {
  return (
    <Root data-active={active} className={className} onClick={onClick}>
      {label}
    </Root>
  )
}

const Root = styled.div`
  width: 35px;
  height: 30px;
  display: grid;
  place-items: center;
  place-content: center;

  border: 1px solid var(--backgroundA-4);
  border-radius: 8px;

  color: var(--text-11);
  cursor: pointer;
  text-align: center;

  font-size: 10px;
  font-weight: 600;
  line-height: 12px; /* 120% */

  transition: all 0.15s linear;

  &:hover {
    background: var(--backgroundA-3);
  }

  &[data-active='true'] {
    border: 1px solid var(--background-6);
    background: var(--backgroundA-5);
  }
`
